<template lang="html">
  <div class="row">
    <div class="col-12">
      <article class=" fc-m-container fc-404-noauth">
        <h2>Page Not Found</h2>
        <p class="">
          We apologize for the inconvenience, but this page does not exist.
        </p>
        <router-link
          v-if="$store.state.auth.is_authenticated"
          class="btn btn-primary"
          to="/leagues"
        >
          Return Home
        </router-link>
        <a v-else v-bind:href="$store.state.homeDomain" class="btn btn-primary">
          Return Home
        </a>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss">
.fc-404-noauth {
  max-width: 500px;
  margin: auto;
}
</style>
